import React, { useEffect } from "react"; // 1. Added useEffect
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom"; // 2. Added useLocation
import "./App.css";

// Components Imports
import Footer from "./Components/Footer/Footer";
import Home from "./Components/Home/Home";
import EtaApplicationForm from "./Components/EtaApplicationForm/EtaApplicationForm";
import AboutUs from "./Components/AboutUs/AboutUs";
import ContactSection from "./Components/ContactSection/ContactSection";
import TermsOfService from "./Components/TermsOfService/TermsOfService";
import PurchaseRefundPolicy from "./Components/TermsOfService/PurchaseRefundPolicy";
import CookiePolicy from "./Components/TermsOfService/CookiePolicy";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import Disclaimer from "./Components/TermsOfService/Disclaimer";
import Navbar from "./Components/Navbar/Navbar";
import EmailWidget from "./Components/EmailWidget/EmailWidget";
import WhatsAppWidget from "./Components/WhatsAppWidget/WhatsAppWidget";

// 3. This small internal component handles the scroll logic
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      {/* 4. Use the internal ScrollToTop here */}
      <ScrollToTop />
      
      <Navbar />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/apply" element={<EtaApplicationForm />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactSection />} />
        <Route path="/terms-of-Service" element={<TermsOfService />} />
        <Route path="/purchase-Refund" element={<PurchaseRefundPolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Routes>

      <EmailWidget /> 
      <WhatsAppWidget />

      <Footer />
    </Router>
  );
}

export default App;